module.exports = __webpack_public_path__ + "static/media/Cha Siu Sou_Empanada de Cha Siu.7b18b1d4.jpg";